import React, { FC, useState, forwardRef, useEffect } from 'react';
import { Select, Spin } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { SelectProps } from 'antd/lib/select';
import { connect } from 'react-redux';

import {
    UserGroupsState,
    search as searchUserGroups,
    getUserGroupsSearchState,
} from '../../store/actions/userGroups';
import {  UserGroup } from '../../store/api/apiTypes';
import { UserGroupListPayload } from '../../store/api/userGroups';
import { MainReducerState } from '../../store/reducers';

interface UsersGroupFilterSelectProps {
    onChange?: (value: any) => void;
    multi?: boolean;
    userGroups: UserGroupsState['search'];
    search: typeof searchUserGroups.trigger;
    size?: SizeType;
    value ?: string[];
    setValue ?: any;
    initialValue ?: UserGroup[];
    filters?: UserGroupListPayload;
}

const UsersGroupFilterSelect: FC<UsersGroupFilterSelectProps> = forwardRef((props, ref: any) => {

    const {onChange, userGroups, search, multi, size, filters} = props;
    const [ value, setValue ] = useState<any>();
    const [ initialValue, setInitialValue ] = useState<UserGroup[]>([]);

    useEffect(() => {
        if (props.initialValue) {
            setValue(props.initialValue.map((a) => a.id));
            setInitialValue(props.initialValue);
            if (onChange) { onChange(props.initialValue.map((a) => a.id || a)); }
        } else {
            setValue([]);
            setInitialValue([]);
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const onFocus: SelectProps<UserGroup['id']>['onFocus'] = () => {
        search({
            search: '',
            pageSize: 15,
            ...filters,
        });
    };

    const onSearch: SelectProps<UserGroup['id']>['onSearch'] = (newValue) => {
        search({
            search: newValue,
            pageSize: 15,
            ...filters,
            throttling: 250,
        });
    };

    const onChangeSelect: SelectProps<UserGroup['id']>['onChange'] = (newValue) => {
        setValue(newValue);
        if (onChange) {onChange(newValue); }
    };

    return (
        <Select
            mode={(multi) ? 'multiple' : undefined}
            size={size}
            ref={ref}
            showSearch
            value={value}
            placeholder="Recherchez un client"
            notFoundContent={userGroups.loading ? <Spin size="small" /> : null}
            filterOption={false}
            onSearch={onSearch}
            onChange={onChangeSelect}
            onFocus={onFocus}
            allowClear
            style={{ width: '100%' }}
        >
            {
                [
                    ...initialValue, // Display initial value
                    ...userGroups.data.items.filter((a) => !initialValue.map((b) => b.id).includes(a.id)), // Search items, excluding initial value
                ].map((userGroup) => (
                <Select.Option value={userGroup.id} key={userGroup.id}>{userGroup.name}</Select.Option>
            ))}
        </Select>
    );

});

UsersGroupFilterSelect.defaultProps = {
    multi: false,
    size: 'small',
};

const mapStateToProps = (state: MainReducerState) => ({
    userGroups: getUserGroupsSearchState(state),
});

export default connect(
    mapStateToProps,
    {
        search: searchUserGroups.trigger,
    },
    null,
    { forwardRef: true },
)(UsersGroupFilterSelect);
